import { Link } from 'react-router-dom';
import { useTranslation } from '../../../i18n/i18n';
import './CmsPopularCategories.css';
import { Icon, star } from '../../Icon/Icon';

const PopularCategoryItemSkeleton = (): JSX.Element => {
	const t = useTranslation().popularCategories;
	return (
		<div className="popular-category skeleton">
			<Link to="#" onClick={() => {}}>
				<img src="/images/arrow-right.svg" alt="" />
				<h3 className="loading-text">{t.loading}</h3>
			</Link>
		</div>
	);
};

type PopularCategoryItemProps = {
	title: string;
	img: string;
	width?: number;
	height?: number;
	link: string;
	onClick?: () => void;
	isSelected?: boolean;
};

const PopularCategoryItem = ({
	title,
	link,
	img,
	width,
	height,
	onClick,
	isSelected,
}: PopularCategoryItemProps): JSX.Element => {
	const handleClick = (e: React.MouseEvent) => {
		e.preventDefault();
		if (onClick) onClick();
	};

	return (
		<div className={`popular-category ${isSelected ? 'selected' : ''}`}>
			<Link to={link} onClick={handleClick}>
				<img src={img} alt={title} width={width} height={height} />
				<h3>{title}</h3>
			</Link>
		</div>
	);
};

export type PopularCategoryItem = {
	img: string;
	width?: number;
	height?: number;
	title: string;
	link: string;
	isSelected?: boolean;
};

type PopularCategoryProps = {
	categories: PopularCategoryItem[];
	onClick?: (item: PopularCategoryItem) => void;
	icon?: string;
	isLoading?: boolean;
	prefixItem?: boolean;
};

export const CmsPopularCategories = ({
	categories,
	onClick,
	icon,
	isLoading,
	prefixItem = false,
}: PopularCategoryProps): JSX.Element => {
	const t = useTranslation().popularCategories;

	return (
		<div className="popular-categories">
			<h2>{t.popularCategories}</h2>
			<div className="category-scroll">
				{prefixItem && (
					<div className="popular-category prefix-item">
						<Icon shape={star} size={18} className="star-icon" />
						{t.popularCategories}
					</div>
				)}
				{isLoading
					? // Show 5 skeleton items while loading
						Array.from({ length: 5 }, (_, i) => <PopularCategoryItemSkeleton key={`skeleton-${i}`} />)
					: categories.map((c, i) => (
							<PopularCategoryItem
								key={i}
								img={icon ?? c.img}
								width={c.width}
								height={c.height}
								title={c.title}
								link={c.link}
								isSelected={c.isSelected}
								onClick={() => onClick && onClick(c)}
							/>
						))}
			</div>
		</div>
	);
};
